"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/AddressIcon.tsx
var AddressIcon_exports = {};
__export(AddressIcon_exports, {
  default: () => AddressIcon_default
});
module.exports = __toCommonJS(AddressIcon_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var AddressIcon = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  {
    fill: "currentColor",
    width: 16,
    height: 16,
    viewBox: "0 0 0.72 0.72",
    ...props,
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M0.62 0.16h-0.16v0.04h0.16v0.42h-0.16v0.04h0.2V0.2a0.04 0.04 0 0 0 -0.04 -0.04",
          className: "clr-i-outline clr-i-outline-path-1"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M0.398 0.06H0.122A0.042 0.042 0 0 0 0.08 0.102V0.66h0.36V0.102A0.042 0.042 0 0 0 0.398 0.06M0.4 0.62h-0.06v-0.06H0.18v0.06H0.12V0.102A0.002 0.002 0 0 1 0.122 0.1h0.275a0.002 0.002 0 0 1 0.002 0.002Z",
          className: "clr-i-outline clr-i-outline-path-2"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "8",
          y: "8",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-3",
          d: "M0.16 0.16H0.2V0.2H0.16V0.16z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "12",
          y: "8",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-4",
          d: "M0.24 0.16H0.28V0.2H0.24V0.16z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "16",
          y: "8",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-5",
          d: "M0.32 0.16H0.36V0.2H0.32V0.16z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "8",
          y: "13",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-6",
          d: "M0.16 0.26H0.2V0.3H0.16V0.26z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "12",
          y: "13",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-7",
          d: "M0.24 0.26H0.28V0.3H0.24V0.26z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "16",
          y: "13",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-8",
          d: "M0.32 0.26H0.36V0.3H0.32V0.26z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "8",
          y: "18",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-9",
          d: "M0.16 0.36H0.2V0.4H0.16V0.36z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "12",
          y: "18",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-10",
          d: "M0.24 0.36H0.28V0.4H0.24V0.36z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "16",
          y: "18",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-11",
          d: "M0.32 0.36H0.36V0.4H0.32V0.36z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "8",
          y: "23",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-12",
          d: "M0.16 0.46H0.2V0.5H0.16V0.46z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "12",
          y: "23",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-13",
          d: "M0.24 0.46H0.28V0.5H0.24V0.46z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "16",
          y: "23",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-14",
          d: "M0.32 0.46H0.36V0.5H0.32V0.46z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "23",
          y: "13",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-15",
          d: "M0.46 0.26H0.5V0.3H0.46V0.26z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "27",
          y: "13",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-16",
          d: "M0.54 0.26H0.58V0.3H0.54V0.26z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "23",
          y: "18",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-17",
          d: "M0.46 0.36H0.5V0.4H0.46V0.36z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "27",
          y: "18",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-18",
          d: "M0.54 0.36H0.58V0.4H0.54V0.36z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "23",
          y: "23",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-19",
          d: "M0.46 0.46H0.5V0.5H0.46V0.46z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "27",
          y: "23",
          width: "2",
          height: "2",
          className: "clr-i-outline clr-i-outline-path-20",
          d: "M0.54 0.46H0.58V0.5H0.54V0.46z"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          x: "0",
          y: "0",
          width: "36",
          height: "36",
          fillOpacity: "0",
          d: "M0 0H0.72V0.72H0V0z"
        }
      )
    ]
  }
);
var AddressIcon_default = AddressIcon;
